import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import type { RootState } from '@swf/core/store';

import { useHomeGamesWidget } from '../../../../model';
import { formatSeasonName } from '../../../../utils/formatSeasonName';
import type { MenuOption } from '../../../DropdownMenu/DropdownMenu';

const useSeason = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const [seasonId, setSeasonId] = useState('');
  const [seasonName, setSeasonName] = useState('');
  const { widgetSelect } = useHomeGamesWidget();
  const seasons = useSelector((rootState: RootState) =>
    widgetSelect.clubSeasons(rootState, clubId)
  );

  const noSeasons = isEmpty(seasons);

  useEffect(() => {
    if (noSeasons) return;

    const [{ seasonId: id, seasonName: name }] = seasons;

    if (!seasonId && id && name) {
      setSeasonId(id.toString());
      setSeasonName(formatSeasonName(name));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seasonId, noSeasons]);

  const handleSeasonSelect = ({ text, value }: MenuOption) => {
    if (!text || !value) return;
    seasonId !== value.toString() && setSeasonId(value.toString());
    seasonName !== text.toString() && setSeasonName(formatSeasonName(text.toString()));
  };

  return {
    handleSeasonSelect,
    noSeasons,
    seasonId,
    seasonName
  };
};

export default useSeason;
